export default __webpack_public_path__ + "static/media/invite-friend-status.0c19d77f.svg";